import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { Typography, useMediaQuery } from '@mui/material';
import CustomizedAccordions from 'components/Common/Accordion/AccordionsCustomized';
import faqBanner from "../../../assets/Image/FAQ/faq-banner.jpg";
import { Divider, Grid } from '@mui/material'
import { Link } from 'react-router-dom';
import { AxiosGet, ResultAPI } from 'service/CommonFunction/TS_function';
import { useEffect } from 'react';
import { i18n } from 'i18n';
import { currentLanguage } from 'service/CommonFunction/AxiosConfig';
const i18nField = 'entities.PublicFAQ.fields';

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`vertical-tabpanel-${index}`}
            aria-labelledby={`vertical-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `vertical-tab-${index}`,
        'aria-controls': `vertical-tabpanel-${index}`,
    };
}

const PublicFAQ = () => {

    const Layout900 = useMediaQuery('(min-width:900px)');
    const Layout1300 = useMediaQuery('(min-width:1300px)');
    const Layout1000 = useMediaQuery('(min-width:1000px)');
    const Layout600 = useMediaQuery('(min-width:600px)');


    const [value, setValue] = React.useState(0);
    const [oDataFAQ, setDataFAQ] = React.useState([]);

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    useEffect(() => {
        GetFAQ();
    }, [])

    const GetFAQ = async () => {

        await AxiosGet(`FAQ/GetFAQ`, { "sLanguage": currentLanguage() }, (res) => {
            ResultAPI(res, null, () => {
                setDataFAQ(res.result?.data || [])
            })
        });
    }

    return (
        <>
            <div style={{ position: 'relative' }}>
                <div style={{ position: 'absolute', top: !Layout900 ? '50%' : '40%', left: '10%' }}>
                    <Typography style={{ lineHeight: "1", color: '#ffffff' }}>
                        <span style={{ fontWeight: "400", display: "flex", fontSize: !Layout900 ? "1.4em" : "3em" }}>
                        {i18n(`${i18nField}.sFAQ`)}
                        </span>{" "}

                        <Grid container spacing={2} direction="row" justifyContent="start" alignItems="center">
                            <Grid item>
                                <Link to="/Home" preventScrollReset={true}>
                                    <span style={{ fontWeight: "400", color: '#ffffff', fontSize: !Layout900 ? "0.8em" : "1em" }}>
                                    {i18n(`${i18nField}.sHomepage`)}
                                    </span>
                                </Link>
                            </Grid>
                            <Grid item>
                                <Divider orientation='vertical' style={{ height: '30px', backgroundColor: '#ffffff' }} />
                            </Grid>
                            <Grid item>
                                <span style={{ fontWeight: "400", fontSize: !Layout900 ? "0.8em" : "1em" }}>
                                    <b> {i18n(`${i18nField}.sContactUs`)}</b>
                                </span>
                            </Grid>
                        </Grid>
                    </Typography>
                </div>
                <img src={faqBanner} alt='' style={{ width: '100%', minHeight: '250px', objectFit: 'cover', boxShadow: '1px 1px 10px 4px rgb(0 0 0 / 20%)' }} />
            </div>
            <div style={{ padding: !Layout600 ? '0em' : '2em' }}>
                <Box className="wrapper" sx={{ margin: "18px" }}>
                    <Box sx={{ width: '100%' }}>
                        <Tabs
                            value={value}
                            onChange={handleChange}
                            textColor="secondary"
                            indicatorColor="secondary"
                            aria-label="secondary tabs example"
                            variant="fullWidth"
                        >
                            {(oDataFAQ || []).length > 0 ?
                                oDataFAQ.map((row, index) => (
                                    <Tab key={row.nQuestionTypeID} label={row.sQuestionType} {...a11yProps(index)} />
                                )) : null
                            }
                        </Tabs>

                        {/* content */}

                        {(oDataFAQ || []).length > 0 ?
                            oDataFAQ.map((row, index) => (
                                <TabPanel key={row.nQuestionTypeID} value={value} index={index}>
                                    <CustomizedAccordions data={row.FAQ || []} />
                                </TabPanel>
                            )) : null
                        }
                    </Box>

                </Box>
            </div>
        </>


    );
}

export default PublicFAQ